// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Cookie--base .Cookie__button{background:#0f0a3b;color:#fff;padding-top:1rem;padding-bottom:1rem}.Cookie--base .Cookie__button:hover{background:#575376}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
